import { useEffect, useRef, useState } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
// evertel
import { useService } from '@evertel/di'
import { DrawerController } from '@evertel/drawer'
import { DrawerHeader } from './elements'
import { Col, Row, ContentPlaceholder } from '@evertel/web/ui'
import { SessionService } from '@evertel/session/SessionService'
import { CurrentUserController } from '@evertel/blue-user'
import { AccountDrawer, AdminDrawer, MessagesDrawer, ManageDrawer } from './drawers'

import { useDrawerNavigation } from './useDrawerNavigation'
import { DrawerNavigationContext } from './DrawerNavigationContext'

const Drawer: React.FC = observer(() => {

    const sessionService = useService(SessionService, [])
    const drawerController = useService(DrawerController, [])
    const currentUserController = useService(CurrentUserController, [])

    const containerRef = useRef<HTMLDivElement>(null)
    const { handleKeyDown, updateNavList } = useDrawerNavigation({ containerRef })


    useEffect(() => {
        if (!sessionService.currentUserId) return

        //this does nothing:
        drawerController.init()

    }, [drawerController, sessionService.currentUserId])

    const userMeta = currentUserController.user?.meta as any
    const display = userMeta?.appearance?.drawerDisplay || 'medium'

    return (
        <DrawerNavigationContext.Provider value={{ updateNavList }}>
            <Col
                data-bs-theme="dark"
                ref={containerRef}
                onKeyDown={handleKeyDown}
                role="navigation"
                aria-label="Main drawer navigation"
                valign="top"
                className={classNames(
                    'drawer animated fadeIn',
                    {
                        [display]: display
                    })}
            >
                <DrawerHeader />
                <PerfectScrollbar options={{ suppressScrollX: true }}>
                    <Col
                        valign="top"
                        className="inner-drawer">
                        {(drawerController.activeSection === 'messages') &&
                        <MessagesDrawer />
                        }
                        {(drawerController.activeSection === 'account') &&
                        <AccountDrawer />
                        }
                        {(drawerController.activeSection === 'manage') &&
                        <ManageDrawer />
                        }
                        {(drawerController.activeSection === 'admin') &&
                        <AdminDrawer />
                        }
                    </Col>
                </PerfectScrollbar>
            </Col>
        </DrawerNavigationContext.Provider>
    )
})

export { Drawer }

